import UploadArea from "./UploadArea";
import { parseErrorMessage } from "../../../utils/parseErrorMessage";

const DesignUpload = ({
  files,
  setFiles,
  figmaUrl,
  setFigmaUrl,
  fileUploadError,
  figmaUrlError,
}) => (
  <div className="app-ai-quote-design-frame">
    <div className="app-ai-quote-design-description">
      <h3>Upload Your Designs / Wireframes</h3>
      <p>
        Please note that the tool supports <span>.png</span>, <span>.jpg</span>,{" "}
        <span>.pdf</span> formats.
        <br />
        If your design is in a different format, please upload screenshots as{" "}
        <span>.png</span> or <span>.jpg</span> files.
      </p>
    </div>
    <div className="app-ai-quote-design-upload">
      <UploadArea files={files} setFiles={setFiles} />
    </div>
    {fileUploadError && fileUploadError.length > 0 && (
      <span className="app-ai-quote-error-input">
        {parseErrorMessage(fileUploadError)}. Support formats: .png, .jpg, .pdf
      </span>
    )}
  </div>
);

export default DesignUpload;
